import React, { Component } from "react";
import { connect } from "react-redux";

import CheckoutSideTotals from "./CheckoutSideTotals";
import CheckoutSideProducts from "./CheckoutSideProducts";

class CheckoutSideSummary extends Component {
	render() {
		const { country = "" } = this.props.shipping;

		return (
			<div className="checkout-section section--small">
				<div className="hbs-cart-order-total">
					<CheckoutSideTotals />
				</div>

				<div className="section">
					<div className="section-heading section--side-heading">
						<span className="txt">Cart Summary</span>
						<span className="content">{country}</span>
					</div>
					<div className="section-content hbs-cart-summary">
						<CheckoutSideProducts />
					</div>
				</div>
				<div>
					<p>HST and bottle deposit is included in the price of wine.
					HST is charged to shipping.</p>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		items: state.cart.items,
		shipping: state.cart.shipping ? state.cart.shipping : {}
	};
};

export default connect(mapStateToProps, {})(CheckoutSideSummary);



// WEBPACK FOOTER //
// ./src/components/checkout/side-summary/CheckoutSideSummary.js